<template>
  <div class="pa-0" >
  

    <div v-if="showSegmentType == 'brille'" class="mb-4">
      <v-row>
        <v-col
          cols="12"
          style="border-bottom: 4px solid #ff8000"
          class="headline pa-2"
        >
          <strong>Neue Berechnung starten</strong>
          <span class="hidden-xs-only">
            &nbsp; | &nbsp;
            <strong>Brille &amp; Sehhilfe</strong>
          </span></v-col
        >
      </v-row>
      <v-row v-if="!sharedDataStore.isMobile()">
        <v-col cols="12">
          <strong>In 30 Sekunden erhalten Sie:</strong>
          <ol class="pl-8 pt-2">
            <li>den Brillen-Tarif der für Sie am besten geeignet ist</li>
            <li>eine detaillierte Tarifanalyse (Testbericht)</li>
            <li>einen Online-Vorab-Annahme-Check</li>
          </ol>
        </v-col>
      </v-row>
    </div>



    <!-- Form first row -->
    <v-form
      ref="berechnungFormRef"
      v-show="!berechnung_submited"
      @submit.prevent="submitBerechnung"
    >
      <!-- ber_jahr, 
                   ber_monat 
                            ber tag - Geburtstag-->

      <v-row>
        <v-col cols="12" md="3" class="subheading"
          >Ihr <b>Geburtstag</b>
          <span v-if="berechnung.ber_erst == 1">
            <br />
            <a @click="resetAll()">neue Person berechnen</a>
          </span>
        </v-col>
        <v-col cols="12" md="9">
          <input-geburtstag-select
            :key="componentKeyStatus"
            v-on:update:year="yearChanged"
            v-on:update:month="monthChanged"
            v-on:update:day="dayChanged"
            :year="berechnung.ber_jahr"
            :month="berechnung.ber_monat"
            :day="berechnung.ber_tag"
        /></v-col>
      </v-row>

      <v-divider class="blue my-2"></v-divider>

    

      <!-- ber_geschlecht - Geschlecht -->

      <v-row>
        <v-col cols="12" md="7">Ihr <b>Geschlecht</b></v-col>
        <v-col cols="12" md="5">
          <v-radio-group class="pl-4 ma-0" v-model="berechnung.ber_geschlecht">
            <v-row>
              <v-col md="6" style="min-width: 80px">
                <v-radio
                  key="0"
                  label="Frau"
                  color="green"
                  :value="0"
                ></v-radio>
              </v-col>

              <v-col md="6" style="min-width: 80px">
                <v-radio
                  key="1"
                  label="Mann"
                  color="green"
                  :value="1"
                ></v-radio>
              </v-col>
            </v-row> </v-radio-group
        ></v-col>
      </v-row>

      <v-divider class="blue my-2"></v-divider>

      <v-row>
        <v-col cols="12" md="7" class="subheading"
          >Wie sind Sie <b>versichert</b>?</v-col
        >
        <v-col cols="12" md="5">
          <v-select
            background-color="white"
            v-model="berechnung.ber_gesetzl"
            :items="versicherungsArten"
            item-value="id"
            item-title="name"
            single-line
          ></v-select>
          <span v-if="berechnung.ber_segment < 2">
            <wtb-check-box
              label-data="möchte  Zahnversicherung wechseln"
              color="green"
              class="caption"
              @change="showTarifSuche()"
              :input="berechnung.ber_wechsel"
              @update:input="updateValueBer('ber_wechsel', $event)"
            />
          </span>
        </v-col>
      </v-row>
     


      <v-divider class="mb-3"></v-divider>

      <!-- Start Brille -->
      <div
        v-if="showSegmentType == 'brille'"
      >
        <berechnung-form-row>
          <template v-slot:title>
            <div>
              Haben Sie bereits eine
              <strong>Sehhilfe</strong> oder ist eine solche angeraten?
            </div>
            <div class="caption"></div>
          </template>

          <template v-slot:input>
            <v-radio-group
              @change="resetSehhilfe()"
              class="pa-0 ma-0"
              v-model="berechnung.ber_brille_ja"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </template>
        </berechnung-form-row>
      </div>

     
      <div v-if="showSegmentType == 'brille'">
        <berechnung-form-row v-if="berechnung.ber_brille_ja == 1">
          <template v-slot:title>
            <div class="white pa-4">
              Haben Sie neben einer eventuellen Sehschwäche
              <strong>weitere Augenkrankheiten?</strong>
            </div>
          </template>

          <template v-slot:input>
            <div class="white pa-4">
              <v-radio-group
                class="pa-0 ma-0"
                v-model="berechnung.ber_brille_krankheit"
              >
                <v-row>
                  <v-col cols="6" style="min-width: 80px">
                    <v-radio
                      key="1"
                      label="Ja"
                      color="green"
                      :value="1"
                    ></v-radio>
                  </v-col>
                  <v-col cols="6" style="min-width: 80px">
                    <v-radio
                      key="0"
                      label="Nein"
                      color="green"
                      :value="0"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            <div>
              Möchten Sie eine
              <strong>Sonnenbrille mit Sehstärke</strong>
              mitversichern?
            </div>
          </template>

          <template v-slot:input>
            <v-radio-group
              class="pa-0 ma-0"
              v-model="berechnung.ber_brille_sonnenbrille"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            <div>
              Haben Sie bereits eine
              <b>Gleitsichtbrille</b> oder planen eine Gleitsichtbrille zu
              benutzen?
            </div>
          </template>

          <template v-slot:input>
            <v-radio-group
              class="pa-0 ma-0"
              v-model="berechnung.ber_brille_gleitsicht"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            <div>
              Möchten Sie
              <strong>Augenlaser-Operationen (Lasik)</strong>
              mitversichern?
            </div>
          </template>

          <template v-slot:input>
            <v-radio-group
              class="pa-0 ma-0"
              v-model="berechnung.ber_brille_lasik"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </template>
        </berechnung-form-row>

        <berechnung-form-row>
          <template v-slot:title>
            <div>
              Möchten Sie eine
              <strong>Hörgerät</strong> mitversichern?
            </div>
          </template>

          <template v-slot:input>
            <v-radio-group
              @change="resetSehhilfe()"
              class="pa-0 ma-0"
              v-model="berechnung.ber_hoergeraet_versicherung"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </template>
        </berechnung-form-row>

        <berechnung-form-row v-if="berechnung.ber_hoergeraet_versicherung == 1">
          <template v-slot:title>
            <div class="white pa-4">
              Tragen Sie eine Hörhilfe, ist eine Hörgeräteversorgung angeraten?
            </div>
          </template>

          <template v-slot:input>
            <div class="white pa-4">
              <v-radio-group
                class="pa-0 ma-0"
                v-model="berechnung.ber_hoergeraet_massnahme"
              >
                <v-row>
                  <v-col cols="6" style="min-width: 80px">
                    <v-radio
                      key="1"
                      label="Ja"
                      color="green"
                      :value="1"
                    ></v-radio>
                  </v-col>
                  <v-col cols="6" style="min-width: 80px">
                    <v-radio
                      key="0"
                      label="Nein"
                      color="green"
                      :value="0"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </template>
        </berechnung-form-row>
      </div>

      <!-- Ende Brille -->

        <!-- ENDE FZ -->

      <!-- Ende Zahnfragen -->
      <!-- ErstInformationen -->

      <v-row class="py-4 pl-2" v-if="berechnung.ber_erst == 0">
        <v-col cols="12" md="1">
          <v-checkbox
            color="green"
            @click="erstInfoChecked()"
            :rules="validateCheckbox()"
            class="py-0 my-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="11">
          <h3>
            <span class="text-green">Ja,</span> ich habe die Erstinformation für
            Kunden erhalten
          </h3>

          <a @click="erstInfoChecked()">
            Erstinformationen für Versicherungsmakler
          </a>
          gemäß § 15 VersVermV
          <a @click="showErstInfoPop = !showErstInfoPop"
            >jetzt anzeigen oder herunterladen.</a
          >
          <p v-if="errorMessage" class="text-orange">{{ errorMessage }}</p>
        </v-col>
      </v-row>

      <v-row class="py-4 pl-2" v-if="berechnung.ber_erst == 0 && berErstError">
        <v-col cols="12"
          ><h3 class="text-orange">
            Bitte setzen Sie den Haken auf "Ja" um eine Berechnung zu starten
          </h3></v-col
        >
      </v-row>
      

      <!-- Submit Berechnung -->
      <v-row class="py-4 pl-2" v-if="showGeburtstagFehler">
        <v-col cols="12"
          ><h3 class="text-orange">
            Bitte geben Sie ein Geburtsdatum an
          </h3></v-col
        >
      </v-row>
      <v-btn
            color="primary"
            style="height: 48px"
            elevated
            tile
            rounded="0"
            type="submit"
            class="button_caps"
            tonal
            value="jetzt Berechnung starten &nbsp; Ergebnis anzeigen"
          >
            <span class="text-white" v-if="!sharedDataStore.isMobile()">
              <b style="font-size: 24px">Vergleich starten | </b
              ><span style="font-size: 24px">jetzt hier klicken</span>
            </span>
            <span v-if="sharedDataStore.isMobile()" style="font-size: 24px">
              Vergleich starten
            </span>
          </v-btn>
     
      <v-row>
        <v-col cols="12">
          <h3>Der Rechner zeigt Ihnen sofort:</h3>
          <ul v-if="berechnung.ber_segment == 2">
            <li>die leistungstärksten Zusatzversicherungen für Sehhilfen</li>
          </ul>

        
        </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-dialog width="777" v-model="showErstInfoPop">
        <v-card>
          <erst-info-pop />
        </v-card>
      </v-dialog>
    </v-row>
    <div v-if="appLoaded" id="appLoaded"></div>
  </div>
</template>

<script setup>
  import {
    ref,
    reactive,
    getCurrentInstance,
    watchEffect,
    computed,
    onMounted,
    defineEmits,
    watch,
  } from "vue";
  import WtbCheckBox from "@/components/berechnung/form/WtbCheckBox";
  import BerechnungFormRow from "@/components/berechnung/form/BerechnungFormRow";
  import InputGeburtstagSelect from "@/components/berechnung/form/InputFormGeburtstagSelect";

  import ErstInfoPop from "@/components/berechnung//info/ErstInfoPop";
  import { useBerechnungStore } from "@/stores/berechnung";
  import { useSharedDataStore } from "@/stores/sharedData";
  import { useGuestStore } from "@/stores/guest";

  import BaseCalls from "@/services/BaseCalls";

  const guestStore = useGuestStore();
  const sharedDataStore = useSharedDataStore();
  const emit = defineEmits(["updateBerechnung"]);

  const berechnungStore = useBerechnungStore();
  const { proxy } = getCurrentInstance();
  
  const showKfoInfo = ref(false);
  const showErstInfoPop = ref(false);
  const componentKeyStatus = ref(0);
  const routeSegment = ref(1);
  const appLoaded = ref(true);
  const showGeburtstagFehler = ref(false);
  const berechnung = reactive({
    ber_guest_id: 0,
    ber_rechner_type: 1,
    ber_wechsel_tarif_id: 0,
    ber_annahme_tarif_id: 0,
    ber_kunden_id: "0",
    ber_segment: 2,
    ber_wechsel: 0,
    ber_alter: 0,
    ber_plz: "",
    ber_aufbiss: 0,
    ber_bruecke: 0,
    ber_bleaching: 0,
    ber_kronen: 0,
    ber_geschlecht: 1,
    ber_gesetzl: 1,
    ber_pkv_zahn_erstattung: 0,
    ber_zahnmass: 0,
    ber_zahnmass_2: 1,
    ber_sofort: 0,
    ber_tag: new Date().getDate(),
    ber_monat: new Date().getMonth() + 1,
    ber_jahr: new Date().getFullYear(), // Änderung: Verwende getFullYear statt getYear + 1900
    ber_zb_3: 0,
    ber_zahnfehl: 0,
    ber_ze_ja: 0,
    ber_luecke: 0,
    ber_luecke_vers: 0,
    ber_zahnersetzt: 0,
    ber_zahnersatz_10: 0,
    ber_kfoja: 0,
    ber_screen_size: window.innerWidth, // Beachte: Die Verwendung von `screen.width` ist statisch; `window.innerWidth` reflektiert die tatsächliche Fensterbreite
    ber_erst: 0,
    ber_brille_ja: 0,
    ber_brille_dioptrien: 0,
    ber_brille_krankheit: 0,
    ber_brille_sonnenbrille: 0,
    ber_brille_gleitsicht: 0,
    ber_hoergeraet_versicherung: 0,
    ber_hoergeraet_massnahme: 0,
    ber_brille_lasik: 0,
    ber_top_gesund: 0,
  });

  const defaultValues = reactive({
    ...berechnung,
  });

  const versicherungsArten = ref([
    { id: 1, name: "gesetzliche Krankenkasse" },
    { id: 2, name: "private Krankenversicherung" },
    { id: 3, name: "Heilfürsorge" },
    { id: 4, name: "gesetzliche Krankenkasse & Beihilfe" },
    { id: 5, name: "freie Heilfürsorge & Beihilfe" },
  ]);

  const berechnung_submited = ref(false);
  const berechnungFormRef = ref(null);
  const sucheTarife = ref([]);
  const isChecked = ref(false);
  const errorMessage = ref("");
  const berErstError = ref(false);

  const resetAll = () => {
    console.log("reset berechnung");
    Object.assign(berechnung, defaultValues);
  };
  // Validierungsfunktion
  const validateCheckbox = () => {
    if (!isChecked.value) {
      errorMessage.value =
        "Sie müssen den Bedingungen zustimmen, um fortzufahren.";
    } else {
      errorMessage.value = "";
    }
  };
  function showTarifSuche() {
    if (berechnung.ber_wechsel == 1) {
      getAlleZahnTarife();
    }
  }
  function checkCurrentDate() {
    const heute = new Date();
    const aktuellesJahr = heute.getFullYear();
    const aktuellerMonat = heute.getMonth() + 1; // Monate sind 0-basiert, daher +1
    const aktuellerTag = heute.getDate();

    if (
      berechnung.ber_jahr === aktuellesJahr &&
      berechnung.ber_monat === aktuellerMonat &&
      berechnung.ber_tag === aktuellerTag
    ) {
      return true;
    } else {
      return false;
    }
  }
  function checkBerechnung() {
    let checkPassed = true;
    showGeburtstagFehler.value = false;
    if (checkCurrentDate()) {
      showGeburtstagFehler.value = true;
    }
    if (berechnung.ber_erst == 0) {
      checkPassed = false;
      berErstError.value = true;
      console.log("ber_erst check");
    }
    if (berechnungFormRef.value && !berechnungFormRef.value.validate()) {
      checkPassed = false;
      console.log("checkPassfalse");
    }
    console.log("checkPassed" + checkPassed);
    return checkPassed;
  }

  async function getAlleZahnTarife() {
    let select = {};
    select.action = "getAlleZahnTarife";
    try {
      const resp = await BaseCalls.postTarif(select); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.tarife) {
        sucheTarife.value = resp.data.tarife;
      }
    } catch (err) {
      console.log("error tarife");
    }
  }
  async function submitBerechnung() {
    if (!checkBerechnung()) {
      return false;
    }

    // berechnung.token =
    //   "92418073005bd16ead01dcfcb713a5e580cf171c66982171ef08ff2169f94f93";
    berechnung.action = "insertBerechnung";
    berechnung.berGestartet = true;
    console.log("berechnung gestartet");
    try {
      const resp = await BaseCalls.postBerechnung(berechnung); // Korrigiert, um .value zu verwenden

      if (resp.data && resp.data.berechnung) {
        console.log("insert erfolgreich" + resp.data.berechnung);
        berechnungStore.setBerechnung(resp.data.berechnung);
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  const updateValueBer = (key, newValue) => {
    console.log("New: " + newValue);
    berechnung[key] = newValue;
  };
  function resetSehhilfe() {
    if (berechnung.ber_brille_ja == 0) {
      berechnung.ber_brille_krankheit = "0";
    }
    if (berechnung.ber_hoergeraet_versicherung == 0) {
      berechnung.ber_hoergeraet_massnahme = "0";
    }
  }


  function dayChanged(day) {
    // $log.debug(`day changed: ${day}`)
    berechnung.ber_tag = day;
    handleBirthdayChanged();
  }
  function monthChanged(month) {
    berechnung.ber_monat = month;
    handleBirthdayChanged();
  }
  function yearChanged(year) {
    berechnung.ber_jahr = year;
    handleBirthdayChanged();
  }

  function handleBirthdayChanged() {
    showGeburtstagFehler.value = false;
    calcAge();

    if (berechnung.ber_alter <= 6) {
      berechnung.ber_luecke = "0";
      berechnung.ber_luecke_vers = "0";
      berechnung.ber_kronen = "0";
      berechnung.ber_ze_ja = "0";
      berechnung.ber_bruecke = "0";
      berechnung.ber_zahnersetzt = "0";
      berechnung.ber_zb_3 = "0";
    }

    if (berechnung.ber_alter <= 9) {
      showKfoInfo.value = false;
      berechnung.ber_kfoja = "1";
    }

    if (berechnung.ber_alter >= 10 && berechnung.ber_alter <= 17) {
      showKfoInfo.value = true;
      berechnung.ber_kfoja = "1";
    }

    if (berechnung.ber_alter >= 18) {
      berechnung.ber_kfoja = "0";
      showKfoInfo.value = false;
    }
  }

  function calcAge() {
    // let age = DateHelper.calcAge(
    //   berechnung.ber_tag,
    //   berechnung.ber_monat,
    //   berechnung.ber_jahr
    // );
    let age = proxy.$calcAge(
      berechnung.ber_tag,
      berechnung.ber_monat,
      berechnung.ber_jahr
    );
    berechnung.ber_alter = age;
  }

  function erstInfoChecked() {
    berechnung.ber_erst = 1;
  }



  const showSegmentType = computed(() => {
  
      return "brille";
   
  });

  watchEffect(() => {
    if (berechnungStore.berechnung) {
      componentKeyStatus.value = componentKeyStatus.value + 1;

      // Iteriere durch die Schlüssel des neuen Objekts und aktualisiere das reaktive Objekt

      Object.keys(berechnungStore.berechnung).forEach((key) => {
        if (key !== "ber_guest_id") {
          berechnung[key] = berechnungStore.berechnung[key];
        }
        if (
          guestStore.guest.guest_id !== 0 &&
          berechnungStore.berechnung["ber_guest_id"] !==
            guestStore.guest.guest_id
        ) {
          berechnung["ber_guest_id"] = guestStore.guest.guest_id;
        } else {
          berechnung["ber_guest_id"] =
            berechnungStore.berechnung["ber_guest_id"];
        }
        console.log(guestStore.guest.guest_id);
      });
      if (berechnung.ber_segment != routeSegment.value) {
        // console.log("berechnung.ber_segment != routeSegment.value");
        berechnung.ber_segment = routeSegment.value;
      }
    }
  });
  onMounted(() => {
    routeSegment.value = 2;
   
  });
  watch(berechnung, (newValue) => {
    emit("updateBerechnung", newValue); // Emit das Update Event mit dem neuen Wert
  });
</script>
